import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, ArrowUpRight, MessageSquare } from "lucide-react";
import WhatsAppIcon from "@/components/WhatsAppIcon";
import Logo from "@/components/Logo";
import { COMPANY, SERVICES } from "@/lib/site";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-zinc-950 border-t border-zinc-800 mt-12"
    >
      <div className="container-max py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <Logo variant="stacked" />
          <p className="text-zinc-400 mt-6 max-w-md leading-relaxed">
            Industrial-grade flooring &amp; exterior envelope contractors. We
            engineer surfaces that survive the toughest operations — and look
            sharp doing it.
          </p>
          <Link
            to="/contact"
            data-testid="footer-cta"
            className="btn-primary mt-8"
          >
            Start a project <ArrowUpRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="md:col-span-3">
          <h4 className="font-heading text-xs tracking-[0.3em] uppercase text-zinc-500 mb-5">
            Services
          </h4>
          <ul className="space-y-3">
            {SERVICES.map((s) => (
              <li key={s.slug}>
                <Link
                  to="/services"
                  className="text-zinc-300 hover:text-[#FF5A00] transition-colors text-sm"
                >
                  {s.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="font-heading text-xs tracking-[0.3em] uppercase text-zinc-500 mb-5">
            Contact
          </h4>
          <ul className="space-y-3 text-sm text-zinc-300">
            <li className="flex items-start gap-3">
              <Phone className="w-4 h-4 mt-1 text-[#FF5A00]" />
              <a
                href={`tel:${COMPANY.phoneRaw}`}
                className="hover:text-[#FF5A00] transition-colors"
              >
                {COMPANY.phone}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <MessageSquare className="w-4 h-4 mt-1 text-[#FF5A00]" />
              <a
                href={COMPANY.smsHref}
                className="hover:text-[#FF5A00] transition-colors"
                data-testid="footer-text-link"
              >
                Text {COMPANY.phone}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <WhatsAppIcon className="w-4 h-4 mt-1 text-[#25D366]" />
              <a
                href={COMPANY.whatsappHref}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#25D366] transition-colors"
                data-testid="footer-whatsapp-link"
              >
                WhatsApp {COMPANY.phone}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Mail className="w-4 h-4 mt-1 text-[#FF5A00]" />
              <a
                href={`mailto:${COMPANY.email}`}
                className="hover:text-[#FF5A00] transition-colors"
              >
                {COMPANY.email}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin className="w-4 h-4 mt-1 text-[#FF5A00]" />
              <span>{COMPANY.serviceArea}</span>
            </li>
            <li className="flex items-start gap-3">
              <Clock className="w-4 h-4 mt-1 text-[#FF5A00]" />
              <span>{COMPANY.hours}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-zinc-800">
        <div className="container-max py-6 flex flex-col md:flex-row justify-between items-center gap-3">
          <p className="text-xs tracking-widest uppercase text-zinc-500 font-heading">
            © {new Date().getFullYear()} Vision Era Construction · Licensed
            &amp; Insured · All rights reserved
          </p>
          <div className="flex gap-6 text-xs tracking-widest uppercase text-zinc-500 font-heading">
            <span>WSIB Covered</span>
            <span>Food-Safety Compliant</span>
            <span>Insured</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
